export interface Article {
  id: number;
  title: string;
  slug: string;
  excerpt: string;
  content: string;
  categoryId: number;
  author: string;
  avatar: string;
  publishDate: string;
  views: number;
  likes: number;
  comments: number;
  isHot: boolean;
  isNew: boolean;
  isFeatured: boolean;
  tags: string[];
  coverImage: string;
}

export interface Category {
  id: number;
  name: string;
  slug: string;
  description: string;
  icon: string;
  count: number;
}

export const categories: Category[] = [
  { id: 1, name: '恋爱技巧', slug: 'love-skills', description: '分享恋爱中的沟通技巧、约会指南与关系经营之道', icon: 'ri-heart-line', count: 128 },
  { id: 2, name: '情感故事', slug: 'love-stories', description: '真实动人的情感故事分享，让每一份感动被看见', icon: 'ri-book-open-line', count: 245 },
  { id: 3, name: '婚姻家庭', slug: 'marriage-family', description: '婚姻经营、家庭关系、婆媳相处等话题交流', icon: 'ri-home-heart-line', count: 167 },
  { id: 4, name: '单身交友', slug: 'dating', description: '单身朋友的交流天地，拓展社交圈，遇见缘分', icon: 'ri-user-heart-line', count: 312 },
  { id: 5, name: '心理情感', slug: 'psychology', description: '情感心理学知识、情绪管理、自我成长探索', icon: 'ri-mental-health-line', count: 98 },
  { id: 6, name: '休闲灌水', slug: 'leisure', description: '轻松闲聊，分享生活趣事，释放压力的小天地', icon: 'ri-cup-line', count: 456 },
  { id: 7, name: '情感问答', slug: 'qa', description: '专业情感问答，你的烦恼在这里有人倾听和解答', icon: 'ri-question-answer-line', count: 89 },
  { id: 8, name: '活动公告', slug: 'announcements', description: '论坛最新活动、线下聚会、线上讲座信息发布', icon: 'ri-megaphone-line', count: 34 },
];

export const articles: Article[] = [
  {
    id: 1,
    title: '如何在第一次约会中留下好印象？十个实用小技巧',
    slug: 'first-date-impression-tips',
    excerpt: '第一次约会总是让人既期待又紧张。如何让对方在短短几个小时内对你产生好感？本文总结了十条经过验证的约会技巧，帮你从容应对。',
    content: `<p>第一次约会，是两个人从陌生走向熟悉的关键时刻。如何在短短几个小时内，让对方对你留下深刻印象？以下十个实用技巧，或许能帮到你。</p>
<h2>1. 选择合适的约会地点</h2>
<p>第一次约会最好选择一个安静、舒适的环境。咖啡馆或安静的餐厅是不错的选择，这样既有私密空间方便交流，又不会太过正式给人压力。避免选择电影院——两个小时的沉默并不利于彼此了解。</p>
<h2>2. 着装得体但不刻意</h2>
<p>穿着打扮要符合场合，干净整洁是第一要务。不必过于隆重，但也要展现出你对这次约会的重视。提前了解约会地点，选择合适的着装风格。</p>
<h2>3. 做一个好的倾听者</h2>
<p>很多人在约会时过于关注"自己该说什么"，却忽略了倾听的重要性。真诚地倾听对方说话，适时回应和提问，会让对方感受到被尊重和关注。记住，好的对话是双向的，不是独角戏。</p>
<h2>4. 保持自然真诚的态度</h2>
<p>不要刻意塑造一个不符真实的形象。做真实的自己，展现真实的个性。伪装或许能撑过第一次约会，但长期关系终究需要真实的连接。真诚永远是最大的魅力。</p>
<h2>5. 找到共同话题</h2>
<p>约会前可以通过聊天了解对方的兴趣爱好，准备一些可能的共同话题。旅行经历、美食偏好、童年趣事都是不错的话题方向。避免在第一次约会就讨论过于沉重或私密的话题。</p>
<h2>6. 注意肢体语言</h2>
<p>微笑、适度的眼神交流、开放的姿态——这些非语言信号传递着友好和兴趣。同时也要观察对方的肢体语言，如果对方频繁看手机或刻意拉开距离，可能意味着需要调整节奏。</p>
<h2>7. 合理控制时间</h2>
<p>第一次约会建议控制在两到三小时。时间太长容易疲惫或冷场，太短则显得敷衍。在气氛正好的时候结束约会，留下期待感，比拖到无话可说要好得多。</p>
<h2>8. 主动但不越界</h2>
<p>表现出你的兴趣和主动性，但尊重对方的边界。约会是互相了解的过程，不是急着推进关系。把握好分寸，让对方感到舒适和安全。</p>
<h2>9. 避免谈论前任</h2>
<p>这几乎是第一次约会的铁律。谈论前任会让对方感到尴尬，也是一个不自信的信号。把话题聚焦在当下和未来，而不是过去。</p>
<h2>10. 约会后的跟进</h2>
<p>约会结束后，可以发一条简短的感谢信息，表达你对这次约会的感受。如果彼此都有继续了解的意愿，可以自然地约定下一次见面。不要让对方猜测你的想法，适当的坦诚会让人感到踏实。</p>
<p>记住，每一次约会都是一次宝贵的学习经历。无论结果如何，每一次相遇都在帮你更了解自己想要的是什么。保持开放的心态，享受这个过程。</p>`,
    categoryId: 1,
    author: '温柔的海风',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20portrait%20of%20a%20young%20Chinese%20woman%20with%20warm%20smile%20soft%20natural%20lighting%20against%20clean%20pastel%20background%2C%20editorial%20style%20headshot%2C%20gentle%20expression&width=80&height=80&seq=avatar-01&orientation=squarish',
    publishDate: '2026-08-04',
    views: 15820,
    likes: 2341,
    comments: 189,
    isHot: true,
    isNew: false,
    isFeatured: true,
    tags: ['约会技巧', '恋爱入门', '人际关系'],
    coverImage: 'https://readdy.ai/api/search-image?query=a%20warm%20romantic%20cafe%20scene%20with%20two%20coffee%20cups%20and%20soft%20candlelight%20on%20a%20wooden%20table%2C%20cozy%20atmosphere%20with%20warm%20bokeh%20lights%20in%20background%2C%20aesthetic%20lifestyle%20photography%20with%20soft%20focus&width=800&height=480&seq=article-cover-01&orientation=landscape',
  },
  {
    id: 2,
    title: '异地恋三年，我们终于修成正果了',
    slug: 'long-distance-love-success',
    excerpt: '三年的异地恋，跨越一千公里的思念。从每天的视频通话到终于能够每天牵手，我们的故事也许能给正在异地恋的你一些力量。',
    content: `<p>我和他相识于大学最后一年。毕业后，他去了深圳工作，而我留在北京读研。一千公里的距离，让我们的恋情从一开始就贴上了"异地"的标签。</p>
<h2>初期的挣扎</h2>
<p>异地恋的第一步永远是适应。从每天见面到只能通过屏幕相见，这种落差让人难以接受。我记得刚开始那几个月，几乎每天晚上都会因为想念而偷偷流泪。他也总说，下班后一个人走在深圳的街道上，看着成双成对的路人，心里总有说不出的酸楚。</p>
<p>但我们很快意识到，沉浸在思念的痛苦中只会让彼此更难受。于是我们开始建立属于我们的"异地规则"。</p>
<h2>我们的相处之道</h2>
<p>每天晚上十点，雷打不动的视频通话时间。不管多忙，这个时间我们都会留给对方。周末的时候，我们会一起在线看电影——打开同一部电影，听着对方在电话那头的笑声，仿佛就在身边。</p>
<p>每个月我们会轮流飞到对方的城市见面。虽然机票钱对刚毕业的我们来说是一笔不小的开销，但每一次见面都让我们更加坚定。离别时的拥抱总是特别用力，因为知道下一次见面又要等上一个月。</p>
<h2>那些温暖的瞬间</h2>
<p>有一次我生病发烧，他在电话里焦虑得不行。第二天中午，外卖小哥送来了一份热粥和感冒药——是他远程帮我点的。粥上还贴着一张便利贴，写着"要快点好起来，我周末就来看你"。</p>
<p>还有一次是他的生日，我偷偷请了假飞到深圳，在他公司楼下等他下班。看到我的那一刻，他愣了好几秒，然后冲过来紧紧抱住我。那个拥抱，我到现在都记得。</p>
<h2>终于等到你</h2>
<p>三年后，我研究生毕业了。我毫不犹豫地选择了去深圳发展的机会。当我们终于在同一个城市，每天可以一起吃饭、一起散步、一起入睡的时候，所有的等待都值了。</p>
<p>今年五月，他求婚了。戒指是在我们第一次约会的那个公园里戴上的。他说：从现在开始，我们再也不分开了。</p>
<p>如果你正在经历异地恋，我想对你说：距离从来不是问题，问题在于你们是否愿意为了在一起而努力。当两个人都朝着同一个方向走的时候，再远的路也会走到尽头。</p>`,
    categoryId: 2,
    author: '草莓味的思念',
    avatar: 'https://readdy.ai/api/search-image?query=portrait%20of%20a%20Chinese%20woman%20in%20her%20mid%20twenties%20with%20gentle%20eyes%20and%20warm%20smile%2C%20soft%20lighting%2C%20clean%20cream%20background%2C%20editorial%20style&width=80&height=80&seq=avatar-02&orientation=squarish',
    publishDate: '2026-08-03',
    views: 23450,
    likes: 4120,
    comments: 356,
    isHot: true,
    isNew: false,
    isFeatured: true,
    tags: ['异地恋', '情感故事', '修成正果'],
    coverImage: 'https://readdy.ai/api/search-image?query=two%20hands%20holding%20each%20other%20in%20sunset%20light%20with%20a%20train%20station%20platform%20in%20the%20distance%2C%20warm%20golden%20hour%20glow%2C%20romantic%20and%20hopeful%20atmosphere%2C%20soft%20focus%20cinematic%20photography&width=800&height=480&seq=article-cover-02&orientation=landscape',
  },
  {
    id: 3,
    title: '结婚五年，我总结了幸福婚姻的七个密码',
    slug: 'happy-marriage-secrets',
    excerpt: '五年的婚姻生活让我明白，爱情是婚姻的起点，但绝不是全部。沟通、理解、包容和共同成长，才是让婚姻长久幸福的真正密码。',
    content: `<p>我和先生结婚五年了。这五年里，我们吵过架、冷战过、也无数次想过"当初为什么会选他"。但走到今天，回头看，我想说：婚姻是这世上最值得经营的事。</p>
<h2>密码一：每天至少十分钟的专注对话</h2>
<p>很多人结婚后，夫妻间的交流变成了"记得交电费""孩子作业写了吗"。这些功能性对话固然必要，但不能替代情感的交流。我们约定每天至少有十分钟放下手机，面对面聊聊各自的心情和想法。这十分钟，让我们的感情始终在线。</p>
<h2>密码二：学会正确地吵架</h2>
<p>没有不吵架的夫妻，但可以学会"聪明地吵架"。我们定了几条规则：不翻旧账、不人身攻击、不牵扯双方家庭。吵完架后要有"和解仪式"——通常是他先道歉（笑），然后我们会拥抱一下，表示这件事翻篇了。</p>
<h2>密码三：保持仪式感</h2>
<p>恋爱时的惊喜、节日的小礼物、周末的特别早餐——这些看似形式的东西，其实是感情的养分。仪式感让平淡的生活有了期待和惊喜，也让彼此感受到被重视。</p>
<h2>密码四：给对方空间</h2>
<p>刚结婚时我总觉得夫妻就应该时刻黏在一起。后来发现，各自有独立的空间和爱好，反而让在一起的时光更珍贵。他喜欢周末去打篮球，我喜欢一个人逛街看书。各自充电之后，我们在一起时话题反而更多了。</p>
<h2>密码五：财务管理要透明</h2>
<p>钱是很多夫妻矛盾的导火索。我们采用了"共同账户+个人零花钱"的模式。大额支出必须商量，小额消费自由支配。透明和信任，是财务和谐的基石。</p>
<h2>密码六：婆媳关系需要智慧</h2>
<p>这一点我想多说几句。我和婆婆的关系经历过从客气到摩擦再到和谐的过程。关键转折点是我意识到：婆婆不是敌人，她只是一个用不同方式爱我先生的人。我开始主动关心她、向她请教生活经验，关系慢慢就改善了很多。</p>
<h2>密码七：一起成长</h2>
<p>五年里，我们都在变成更好的人。他支持我读完了在职研究生，我也在他创业最艰难的时候给予了全力支持。当我们都在成长，婚姻就有了向前走的动力。</p>`,
    categoryId: 3,
    author: '小确幸的日常',
    avatar: 'https://readdy.ai/api/search-image?query=portrait%20of%20a%20Chinese%20woman%20in%20early%20thirties%20with%20warm%20confident%20smile%2C%20natural%20makeup%2C%20soft%20studio%20lighting%20against%20cream%20backdrop%2C%20professional%20headshot&width=80&height=80&seq=avatar-03&orientation=squarish',
    publishDate: '2026-08-02',
    views: 18920,
    likes: 3567,
    comments: 278,
    isHot: true,
    isNew: false,
    isFeatured: false,
    tags: ['婚姻经营', '夫妻相处', '婆媳关系'],
    coverImage: 'https://readdy.ai/api/search-image?query=cozy%20living%20room%20with%20warm%20lighting%20and%20two%20mugs%20of%20tea%20on%20a%20wooden%20coffee%20table%2C%20soft%20throw%20blanket%20and%20books%2C%20peaceful%20home%20atmosphere%20with%20golden%20afternoon%20sunlight&width=800&height=480&seq=article-cover-03&orientation=landscape',
  },
  {
    id: 4,
    title: '如何走出失恋阴影？心理咨询师给你的四个建议',
    slug: 'how-to-move-on-from-breakup',
    excerpt: '失恋的痛苦是真实存在的。作为一名心理咨询师，我想从专业的角度告诉你，失恋后的情绪变化是正常的，走出阴影需要时间和正确的方法。',
    content: `<p>作为一名从业十年的心理咨询师，我接待过很多因情感受伤而来访的求助者。失恋带来的痛苦是真实且深刻的，但这段经历也可以成为个人成长的契机。</p>
<h2>第一阶段：允许自己悲伤</h2>
<p>很多来访者会问："我是不是太脆弱了？为什么这么久还走不出来？"我的回答是：悲伤不是脆弱的表现。一段感情的结束意味着一整套生活模式的崩塌——你失去的不只是一个恋人，还有与之相关的习惯、期待和未来规划。</p>
<p>给自己设定一段"悲伤期"是完全正常的。你可以哭、可以写日记、可以听那些催泪的歌。关键在于，悲伤要有期限。我建议设定为两周到一个月，之后就要开始慢慢走出来。</p>
<h2>第二阶段：切断联系，创造空间</h2>
<p>这是最难但最关键的一步。删除或隐藏社交媒体的联系方式，暂时避开共同的朋友圈。这不是绝情，而是给自己创造愈合的空间。很多来访者反复走不出来，正是因为不断通过社交网络关注前任的动态，一次次揭开伤疤。</p>
<p>如果真的有重要事务需要联系（比如物品归还），请一位朋友代为处理，或者选择最短的沟通方式，不拖泥帶水。</p>
<h2>第三阶段：重建自我认同</h2>
<p>一段亲密关系往往会让我们将自己的身份与"某某的伴侣"绑定。分手后，需要重新找到"我是谁"的答案。尝试那些恋爱时放下的事情：学习一项新技能、重拾旧的爱好、和老朋友重新联系。</p>
<p>我有一个来访者，分手后报名学了烘焙。半年后，她不仅走出了阴影，还开了一家小小的烘焙工作室。她说："这间工作室是我给自己的礼物。"</p>
<h2>第四阶段：重新出发</h2>
<p>当你发现自己可以坦然提起过去、不再被情绪淹没的时候，就是准备好重新出发的时候了。新的恋情不是忘记过去的手段，而是你准备好迎接新开始的证明。</p>
<p>最后想说的是，每一次失恋都在帮你划清界限，让你更清楚自己想要什么样的伴侣和关系。痛苦会过去，而你从中学到的东西，会陪着你走向下一段更好的旅程。</p>`,
    categoryId: 5,
    author: '心理咨询师林悦',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20portrait%20of%20a%20Chinese%20woman%20in%20her%20thirties%20with%20glasses%20and%20warm%20professional%20demeanor%2C%20soft%20lighting%2C%20cream%20background%2C%20therapist%20headshot&width=80&height=80&seq=avatar-04&orientation=squarish',
    publishDate: '2026-08-01',
    views: 26780,
    likes: 5120,
    comments: 467,
    isHot: true,
    isNew: false,
    isFeatured: true,
    tags: ['失恋', '情感修复', '心理健康'],
    coverImage: 'https://readdy.ai/api/search-image?query=peaceful%20morning%20scene%20with%20sunlight%20streaming%20through%20a%20window%20onto%20a%20comfortable%20armchair%20and%20a%20journal%20with%20a%20pen%2C%20healing%20and%20hopeful%20atmosphere%2C%20warm%20neutral%20tones%20with%20soft%20shadows&width=800&height=480&seq=article-cover-04&orientation=landscape',
  },
  {
    id: 5,
    title: '单身也可以很精彩：一个人生活的十种快乐',
    slug: 'happiness-of-single-life',
    excerpt: '单身不是一种缺陷，而是一种选择。与其焦虑地等待那个对的人，不如先让自己成为一个对的人。分享一个人生活的十种快乐。',
    content: `<p>在这个"催促脱单"的文化里，单身似乎成了一种需要被"解决"的状态。但我想说，单身时光可能是你一生中最自由、最能探索自己的黄金时期。</p>
<h2>1. 完全属于自己的时间</h2>
<p>周末的早晨，你可以睡到自然醒，然后决定是去看展、爬山，还是窝在家里看一整天电影。没有人需要商量，没有人等你交代。这种自由，是恋爱后很难再有的奢侈品。</p>
<h2>2. 专注于自我成长</h2>
<p>单身时期是自我投资的最佳时机。你可以全力投入事业、学习新技能、读书旅行。我认识的一位朋友，单身两年期间拿到了PMP证书，学会了吉他和潜水，还一个人去了五个国家。</p>
<h2>3. 维护丰富的友谊网络</h2>
<p>恋爱时，社交圈往往会不自觉地缩小。单身让你有更多时间和精力经营友谊，和不同的人交流、碰撞，生活会因此变得丰富和有趣。</p>
<h2>4. 探索自己的兴趣</h2>
<p>单身让你可以随心所欲地探索：今晚想吃日料还是火锅？周末想去爬山还是看海？这些小决定完全由你的心情做主。</p>
<h2>5. 学会与自己相处</h2>
<p>很多人害怕独处，因为独处时会面对真实的自己。但学会与自己和平相处，是所有健康关系的基础。一个人看电影、一个人吃饭，其实都是一种能力。</p>
<h2>6. 保持独立的经济和生活</h2>
<p>单身让你学会完全为自己的生活负责。理财、家务、时间管理——这些独立生活的能力，无论未来是否恋爱，都会让你受益终身。</p>
<h2>7. 不被别人的情绪裹挟</h2>
<p>恋爱关系中，我们总会受到伴侣情绪的影响。单身的你，情绪由自己掌控。这种平和和稳定，是难得的内心力量。</p>
<h2>8. 享受随性的社交</h2>
<p>你可以随时接受朋友的邀约，也可以随时计划一场说走就走的旅行。这种随性而为的自由感，真的很棒。</p>
<h2>9. 建立个人品牌</h2>
<p>单身时期可以全身心投入打造自己的事业和影响力。当你成为一个有趣、有料的人时，遇见对的人只是时间问题。</p>
<h2>10. 相信最好的还在路上</h2>
<p>单身不是因为没有选择，而是因为你有标准。在等待的过程中，先把最好的自己准备好。相信当你足够好的时候，那个足够好的人会出现在你的生命里。</p>`,
    categoryId: 4,
    author: '阳光下的向日葵',
    avatar: 'https://readdy.ai/api/search-image?query=portrait%20of%20a%20young%20Chinese%20woman%20with%20bright%20cheerful%20smile%2C%20outdoor%20natural%20lighting%2C%20casual%20stylish%20look%2C%20warm%20and%20energetic%20vibe%2C%20editorial%20lifestyle%20photography&width=80&height=80&seq=avatar-05&orientation=squarish',
    publishDate: '2026-07-30',
    views: 31200,
    likes: 6789,
    comments: 523,
    isHot: true,
    isNew: false,
    isFeatured: false,
    tags: ['单身生活', '自我成长', '独立女性'],
    coverImage: 'https://readdy.ai/api/search-image?query=a%20young%20woman%20sitting%20on%20a%20sunny%20balcony%20reading%20a%20book%20with%20a%20cup%20of%20coffee%2C%20plants%20around%2C%20city%20view%20in%20background%2C%20peaceful%20and%20free%20lifestyle%2C%20warm%20afternoon%20sunlight%2C%20cozy%20atmosphere&width=800&height=480&seq=article-cover-05&orientation=landscape',
  },
  {
    id: 6,
    title: '情侣旅行必去的五个浪漫目的地推荐',
    slug: 'romantic-travel-destinations',
    excerpt: '旅行是检验情侣关系的最好方式之一。精选五个国内浪漫旅行目的地，从江南水乡到海边日落，每一个都适合创造属于你们的甜蜜回忆。',
    content: `<p>有人说，想知道两个人适不适合在一起，一起旅行一次就知道了。旅行中的点点滴滴——行程规划、突发状况、消费习惯——都在考验着彼此的默契和包容。</p>
<h2>1. 大理——风花雪月的慢生活</h2>
<p>大理有着让人放慢脚步的魔力。和喜欢的人一起在洱海边骑自行车，在古城的小巷里寻找地道美食，在苍山脚下看云卷云舒。这里的每一刻都值得被珍藏。推荐住在洱海边的民宿，早上推开窗就是波光粼粼的湖面和远处的苍山。</p>
<h2>2. 厦门——海风与文艺的邂逅</h2>
<p>鼓浪屿的万国建筑、环岛路的海风、沙坡尾的文艺小店——厦门是一座为恋爱而生的城市。在曾厝垵的小巷里手牵手闲逛，在环岛路上一起等一场日落，在第八菜市场品尝最地道的闽南小吃。文艺又烟火气十足。</p>
<h2>3. 成都——慢悠悠的烟火浪漫</h2>
<p>成都的浪漫，藏在街头巷尾的火锅店里，藏在人民公园的盖碗茶里，藏在锦里的红灯笼下。和爱的人一起逛宽窄巷子、看大熊猫、吃一顿地道的川菜——这种烟火气十足的恋爱，真实又温暖。</p>
<h2>4. 杭州——诗意江南的温柔</h2>
<p>"欲把西湖比西子，淡妆浓抹总相宜"。西湖的四季各有风情，春天的柳浪闻莺、夏天的曲院风荷、秋天的平湖秋月、冬天的断桥残雪。和爱人泛舟西湖，在龙井村品一杯新茶，慢悠悠地感受江南的诗意。</p>
<h2>5. 三亚——热带海岛的激情</h2>
<p>碧海蓝天、椰林树影、细软沙滩——三亚是情侣度假的天堂。在海边看一场壮美的日落，在酒店的无边泳池里享受二人世界，晚上听着海浪声入眠。这里的一切都在说：尽情享受当下。</p>`,
    categoryId: 6,
    author: '旅行中的猫',
    avatar: 'https://readdy.ai/api/search-image?query=portrait%20of%20a%20young%20Chinese%20man%20with%20friendly%20smile%20and%20casual%20travel%20style%2C%20outdoor%20natural%20light%2C%20adventure%20vibe%2C%20editorial%20photography&width=80&height=80&seq=avatar-06&orientation=squarish',
    publishDate: '2026-07-28',
    views: 14580,
    likes: 2890,
    comments: 201,
    isHot: false,
    isNew: true,
    isFeatured: false,
    tags: ['情侣旅行', '浪漫目的地', '旅行攻略'],
    coverImage: 'https://readdy.ai/api/search-image?query=romantic%20sunset%20at%20Erhai%20Lake%20Dali%20with%20mountains%20in%20distance%2C%20bicycle%20path%20along%20lakeshore%20with%20wildflowers%2C%20warm%20golden%20light%2C%20peaceful%20travel%20scene&width=800&height=480&seq=article-cover-06&orientation=landscape',
  },
  {
    id: 7,
    title: '恋爱中的沟通误区：这些话千万别对伴侣说',
    slug: 'communication-mistakes-in-love',
    excerpt: '沟通是恋爱的基石，但很多人在恋爱中不自觉地掉入沟通误区。哪些话会伤害感情？如何表达才能让对方真正理解你？',
    content: `<p>在恋爱中，有些话一旦说出口，就像泼出去的水，再难收回。今天我们来盘点那些恋爱中常见的沟通雷区，以及更好的表达方式。</p>
<h2>沟通误区一：以偏概全的指责</h2>
<p>错误的表达："你总是这样！""你从来不关心我！"这种全盘否定的表达方式，会立刻激起对方的防御心理。没有人是"总是"或"从来不"的，这种极端化的语言只会让沟通变成争吵。</p>
<p>更好的表达："这件事让我感觉没有被关心，我们可以聊聊吗？"用具体的感受代替笼统的指责，对方会更愿意倾听。</p>
<h2>沟通误区二：冷暴力式的沉默</h2>
<p>"我不想说了。""随便你吧。""算了，没什么。"这些话看似在避免冲突，实际上是最伤人的沟通方式。沉默和回避会切断情感的连接，让问题在暗处发酵。</p>
<p>更好的做法：如果你当下情绪太激动需要冷静，可以说："我现在需要一点时间冷静一下，我们半小时后再聊，好吗？"给时间缓冲而不是切断沟通。</p>
<h2>沟通误区三：拿别人做比较</h2>
<p>"你看XX的男朋友多体贴！""别人家的女朋友都会......"比较是关系中的毒药。当你说出这些话的时候，对方听到的不是建议，而是"你不够好"的否定。</p>
<p>更好的表达：直接说出你的需求。"我希望我们周末能多一起出去玩，你愿意吗？"</p>
<h2>沟通误区四：翻旧账</h2>
<p>每次吵架都把之前的事拿出来说，这会让矛盾像滚雪球一样越滚越大。每一次冲突都应该聚焦于当下这件事，而不是把所有历史问题都摊开。</p>
<h2>沟通误区五：语言暴力式的分手威胁</h2>
<p>"那我们分手啊！""这日子没法过了！"把分手挂在嘴边是最消耗感情的行为。每一次发出分手威胁，都在透支对方的信任和安全感。</p>`,
    categoryId: 1,
    author: '知心的树洞',
    avatar: 'https://readdy.ai/api/search-image?query=portrait%20of%20a%20young%20Chinese%20man%20and%20woman%20together%2C%20warm%20and%20intimate%20couple%20portrait%2C%20soft%20lighting%2C%20casual%20style%2C%20editorial%20relationship%20photography&width=80&height=80&seq=avatar-07&orientation=squarish',
    publishDate: '2026-07-26',
    views: 20150,
    likes: 3456,
    comments: 312,
    isHot: false,
    isNew: true,
    isFeatured: false,
    tags: ['恋爱沟通', '情感技巧', '亲密关系'],
    coverImage: 'https://readdy.ai/api/search-image?query=two%20people%20sitting%20on%20opposite%20sides%20of%20a%20cozy%20cafe%20table%20engaged%20in%20deep%20conversation%2C%20warm%20lighting%2C%20intimate%20atmosphere%2C%20soft%20focus%20background%2C%20cinematic%20mood&width=800&height=480&seq=article-cover-07&orientation=landscape',
  },
  {
    id: 8,
    title: '写给即将步入婚姻的你：婚前需要想清楚的五件事',
    slug: 'things-to-consider-before-marriage',
    excerpt: '婚姻是人生中最重要的决定之一。在说出那句"我愿意"之前，有些问题需要两个人认真聊一聊。这五件事，可能会影响你婚后的幸福指数。',
    content: `<p>婚礼可以被精心策划，但婚姻无法彩排。在步入婚姻之前，有些重要的对话需要认真完成。</p>
<h2>一、关于金钱的观念</h2>
<p>金钱是夫妻矛盾的首要来源。婚前的财务对话，包括但不限于：各自的收入和负债情况、婚后的财务管理模式（共同账户还是各自管理）、大额支出的决策机制、对储蓄和投资的态度。不需要完全一致，但需要达成共识。</p>
<h2>二、关于生育的规划</h2>
<p>要不要孩子？什么时候要？要几个？如果遇到生育困难怎么办？这些问题没有标准答案，但需要双方坦诚交流。不要抱着"结婚后自然就会解决"的心态走进婚姻。</p>
<h2>三、关于家庭的边界</h2>
<p>在中国文化背景下，原生家庭的影响不可忽视。婚前需要沟通清楚：和双方父母保持怎样的距离？过年回谁家？父母如果需要照顾怎么办？这些问题处理不好，很可能成为婚姻中的暗礁。</p>
<h2>四、关于冲突的处理方式</h2>
<p>每对夫妻都会吵架，但处理冲突的方式决定了婚姻的质量。观察一下你们现在吵架的"风格"——是冷战型还是爆发型？能不能做到吵完架就翻篇？如果你们现在的冲突处理就不太健康，婚姻不会自动改善这一点。</p>
<h2>五、关于对婚姻的期待</h2>
<p>最后也是最重要的一点：你们各自对婚姻的期待是什么？是灵魂伴侣的浪漫想象？还是柴米油盐的生活伙伴？期待的落差，往往是最令人痛苦的婚姻杀手。坦诚地聊一聊你们各自眼中的"幸福婚姻"是什么样子的。</p>`,
    categoryId: 3,
    author: '小确幸的日常',
    avatar: 'https://readdy.ai/api/search-image?query=portrait%20of%20a%20Chinese%20woman%20in%20early%20thirties%20with%20warm%20confident%20smile%2C%20natural%20makeup%2C%20soft%20studio%20lighting%20against%20cream%20backdrop%2C%20professional%20headshot&width=80&height=80&seq=avatar-03&orientation=squarish',
    publishDate: '2026-07-25',
    views: 11340,
    likes: 1890,
    comments: 156,
    isHot: false,
    isNew: true,
    isFeatured: false,
    tags: ['婚前准备', '婚姻建议', '人生规划'],
    coverImage: 'https://readdy.ai/api/search-image?query=elegant%20wedding%20rings%20with%20soft%20flower%20petals%20on%20a%20delicate%20lace%20fabric%2C%20warm%20golden%20backlight%2C%20romantic%20and%20tender%20atmosphere%2C%20fine%20art%20photography&width=800&height=480&seq=article-cover-08&orientation=landscape',
  },
  {
    id: 9,
    title: '情感问答：喜欢一个人却不敢表白怎么办？',
    slug: 'afraid-to-confess-love',
    excerpt: '暗恋是甜蜜的，也是煎熬的。喜欢一个人却不敢表白，该怎么办？情感专栏为你分析背后的心理，并提供实用的行动建议。',
    content: `<p>读者来信："我喜欢一个同事快半年了，每天看到他都会很开心，但又不敢说出口。怕被拒绝后连朋友都做不成，也怕办公室恋情会被议论。我该怎么办？"</p>
<h2>你害怕的不是表白，而是不确定性</h2>
<p>首先，让我们来拆解你的恐惧。你真正害怕的不是表白这个动作本身，而是表白可能带来的三种结果：被拒绝的尴尬、关系变质的不确定、以及对自我价值的怀疑。</p>
<p>这些恐惧是正常的，也是人之常情。但我想说的是：不说出你的心意，你永远不知道答案，而遗憾比拒绝更让人煎熬。</p>
<h2>行动建议：渐进式试探</h2>
<p>如果你还没有准备好直接表白，可以先做一些渐进式的试探：</p>
<p>第一步：增加互动频率。从工作话题自然延伸到日常生活，比如"周末有什么安排？"看看对方是否愿意和你分享私人生活。</p>
<p>第二步：制造独处机会。约对方一起吃午饭或喝咖啡，观察在非工作场合的相处感受。</p>
<p>第三步：释放善意信号。适当的关心、真诚的赞美、轻微的身体语言暗示。</p>
<p>第四步：如果以上三步反馈都很好，那就可以选择一个合适的时机和场合，真诚地表达你的感受了。</p>
<h2>关于办公室恋情</h2>
<p>办公室恋情确实需要谨慎。我的建议是：先了解公司的相关制度，确认没有明确禁止。在关系确认之前保持低调，不要给彼此带来不必要的压力。如果在一起了，工作中保持专业态度。</p>
<h2>写给正在暗恋的你</h2>
<p>最后想说的是，表白不是为了得到一个结果，而是为了不让自己后悔。人生太短，有些话现在不说，以后可能就没有机会了。勇敢一点，无论结果如何，你都赢得了面对内心真实的自己。</p>`,
    categoryId: 7,
    author: '心理咨询师林悦',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20portrait%20of%20a%20Chinese%20woman%20in%20her%20thirties%20with%20glasses%20and%20warm%20professional%20demeanor%2C%20soft%20lighting%2C%20cream%20background%2C%20therapist%20headshot&width=80&height=80&seq=avatar-04&orientation=squarish',
    publishDate: '2026-07-23',
    views: 8930,
    likes: 1450,
    comments: 234,
    isHot: false,
    isNew: true,
    isFeatured: false,
    tags: ['暗恋', '表白', '情感问答'],
    coverImage: 'https://readdy.ai/api/search-image?query=a%20heart%20shaped%20warm%20glowing%20light%20on%20a%20window%20with%20raindrops%2C%20soft%20bokeh%20city%20lights%20in%20background%2C%20tender%20and%20melancholy%20mood%2C%20romantic%20atmosphere%2C%20fine%20art%20photography&width=800&height=480&seq=article-cover-09&orientation=landscape',
  },
  {
    id: 10,
    title: '论坛公告：八月线下交友活动开始报名啦！',
    slug: 'august-dating-event-signup',
    excerpt: '爱情岛论坛八月线下交友活动正式开启！这次我们为大家准备了丰富有趣的互动环节，欢迎单身的朋友们踊跃报名参加~',
    content: `<p>亲爱的岛友们，八月线下交友活动来啦！经过一个月的精心策划，这次活动绝对值得期待。</p>
<h2>活动详情</h2>
<p><strong>活动时间：</strong>2026年8月24日（周六）14:00-17:00</p>
<p><strong>活动地点：</strong>杭州市西湖区曙光路88号 · 花开半夏咖啡馆</p>
<p><strong>参与人数：</strong>限40人（男女各20人）</p>
<p><strong>报名费用：</strong>68元/人（含饮品和茶点）</p>
<h2>活动流程</h2>
<p>14:00-14:30 签到入场，自由交流</p>
<p>14:30-15:00 破冰游戏——"缘分九宫格"</p>
<p>15:00-15:40 趣味互动——"情感话题对对碰"</p>
<p>15:40-16:20 自由交流 & 桌游时间</p>
<p>16:20-16:50 心动卡片传递环节</p>
<p>16:50-17:00 合影留念 & 活动结束</p>
<h2>报名方式</h2>
<p>请在本帖评论区留下你的联系方式（微信号），或者私信版主"爱情岛小管家"进行报名。名额有限，先到先得！</p>
<h2>温馨提示</h2>
<p>1. 请穿着得体舒适的服装</p>
<p>2. 活动开始前24小时可以免费取消，之后取消不予退款</p>
<p>3. 请带着真诚和开放的心态来参加活动</p>
<p>期待和大家线下见面！让我们一起在这个夏天，遇见心动的可能~</p>`,
    categoryId: 8,
    author: '爱情岛小管家',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20friendly%20avatar%20of%20a%20community%20manager%2C%20warm%20approachable%20smile%2C%20clean%20background%2C%20lifestyle%20portrait%20style&width=80&height=80&seq=avatar-08&orientation=squarish',
    publishDate: '2026-08-05',
    views: 5670,
    likes: 890,
    comments: 134,
    isHot: false,
    isNew: true,
    isFeatured: false,
    tags: ['线下活动', '交友活动', '论坛公告'],
    coverImage: 'https://readdy.ai/api/search-image?query=warm%20and%20cozy%20cafe%20interior%20with%20group%20of%20young%20people%20socializing%20and%20laughing%20together%2C%20warm%20ambient%20lighting%2C%20friendly%20social%20gathering%20atmosphere%2C%20lifestyle%20event%20photography&width=800&height=480&seq=article-cover-10&orientation=landscape',
  },
  {
    id: 11,
    title: '相处三年后，我们为什么选择了分手',
    slug: 'why-we-broke-up-after-three-years',
    excerpt: '没有出轨、没有大的争吵，我们和平分手了。回顾这三年的感情历程，我想分享一些感悟，关于爱情的本质，以及什么样的人才适合长久在一起。',
    content: `<p>写下这篇文章的时候，我们已经分手一个月了。很多人不理解：三年感情，没有原则性问题，为什么说分就分了？</p>
<h2>不是因为不爱，而是爱的方向不同</h2>
<p>我们彼此依然在意对方，这点没什么好否认的。但三年的相处让我们越来越清楚地意识到：我们对未来生活的想象，完全不在一个轨道上。</p>
<p>他想要安稳的生活，在一个城市扎根，朝九晚五，周末养花。我渴望更多的不确定性和探索，想要尝试不同城市的生活，想要创业，想要看看更大的世界。</p>
<p>没有谁对谁错。只是我们想要的人生，画不出同一个圆。</p>
<h2>磨合不是削足适履</h2>
<p>我们也尝试过磨合。他陪我创业了半年，我看得出他的忍耐和不适。我也试着接受朝九晚五的稳定生活，但那种窒息感每天都让我想逃跑。</p>
<p>后来我想明白了：真正的磨合，是大方向一致的前提下，在小事上互相迁就。而不是逼迫对方变成另一个人。当你需要削去太多"我"来适应这段关系的时候，这段关系迟早要走到尽头。</p>
<h2>和平分手的体面</h2>
<p>分手那天，我们在常去的那家餐厅吃了最后一顿饭。没有争吵，没有指责，我们甚至回忆了三年来最开心的那些时刻。最后他送我回家，在楼下拥抱了很久。</p>
<p>"谢谢你三年的陪伴。"我说。</p>
<p>"你也一样。要好好的。"他说。</p>
<h2>写给正在犹豫的你</h2>
<p>如果你也在考虑要不要结束一段看似"没什么问题"的感情，我的建议是：问问自己，五年后的你，会感谢现在的自己坚持下来了，还是会后悔没有早点做出改变？</p>
<p>答案其实一直都在你心里。只是，你需要勇气面对它。</p>`,
    categoryId: 2,
    author: '深海里的星',
    avatar: 'https://readdy.ai/api/search-image?query=portrait%20of%20a%20young%20Chinese%20woman%20looking%20contemplative%20with%20soft%20window%20light%2C%20thoughtful%20expression%2C%20minimal%20makeup%2C%20editorial%20portrait%20style&width=80&height=80&seq=avatar-09&orientation=squarish',
    publishDate: '2026-07-20',
    views: 19780,
    likes: 3890,
    comments: 445,
    isHot: false,
    isNew: false,
    isFeatured: false,
    tags: ['分手', '情感反思', '成长'],
    coverImage: 'https://readdy.ai/api/search-image?query=rainy%20window%20with%20droplets%2C%20view%20of%20city%20lights%20through%20the%20glass%2C%20melancholic%20but%20peaceful%20mood%2C%20warm%20interior%20glow%2C%20contemplative%20atmosphere%2C%20fine%20art%20photography&width=800&height=480&seq=article-cover-11&orientation=landscape',
  },
  {
    id: 12,
    title: '婆媳相处十年，我总结的八条黄金法则',
    slug: 'mother-in-law-relationship-guide',
    excerpt: '十年婚姻，和婆婆相处从最初的互相看不顺眼，到现在的互相心疼。这条路我走了很久，总结出八条婆媳相处的黄金法则。',
    content: `<p>刚结婚的时候，我和婆婆的关系可以用"客气但疏远"来形容。她嫌我做饭不好吃，我觉得她管太多。十年后的今天，她会给我织围巾，我会在周末主动打电话问候她。</p>
<h2>法则一：别把婆婆当妈</h2>
<p>这是我花了好几年才明白的道理。对亲妈可以任性、发脾气、不做家务，但和婆婆之间需要保持一份客气和尊重。与其追求母女般的亲密，不如建立一个互相尊重的友好关系。</p>
<h2>法则二：老公是最好的桥梁</h2>
<p>遇到矛盾，不要让两个女人直接对峙。让老公来做沟通的缓冲区。但要注意：不要让老公传话，而是让他以"我的想法"来表达，避免形成"我老婆说......"的对立局面。</p>
<h2>法则三：在公婆面前多夸老公</h2>
<p>婆婆最听不得别人说她儿子不好。在婆婆面前多夸老公的优点，她会觉得你是个懂得欣赏她儿子的好媳妇。你对她儿子的爱，就是她对你最大的好感来源。</p>
<h2>法则四：经济独立是底气</h2>
<p>保持经济独立，不是不信任，而是给自己一份安全感。当你不依赖任何人的时候，尊重才会是双向的。</p>
<h2>法则五：主动示好不丢人</h2>
<p>节假日送个小礼物，偶尔帮忙做些力所能及的事，这些小小的主动示好，会慢慢融化婆婆的心防。记住，所有的关系都是经营出来的。</p>
<h2>法则六：尊重她的生活习惯</h2>
<p>也许婆婆做饭偏咸，也许她把东西到处乱放，但这些生活习惯是她几十年来形成的。与其试图改变她，不如学会接受和适应。毕竟，你也不希望别人对你的生活方式指手画脚。</p>
<h2>法则七：有边界感地表达</h2>
<p>尊重不等于无底线妥协。如果婆婆的行为确实影响到了你小家庭的生活，要学会温柔但坚定地表达边界。提前和老公商量好策略，一起面对，效果最好。</p>
<h2>法则八：感恩大于计较</h2>
<p>用感恩的心态和婆婆相处。她帮你带孩子，就感谢她的付出。她偶尔说一句不顺耳的话，就当没听见。十年下来你会发现，感恩的心让你的生活轻松很多，而计较只会让自己疲惫不堪。</p>`,
    categoryId: 3,
    author: '温暖如初',
    avatar: 'https://readdy.ai/api/search-image?query=portrait%20of%20a%20mature%20Chinese%20woman%20with%20warm%20gentle%20smile%2C%20motherly%20demeanor%2C%20soft%20natural%20lighting%2C%20kind%20eyes%2C%20editorial%20portrait&width=80&height=80&seq=avatar-10&orientation=squarish',
    publishDate: '2026-07-18',
    views: 16780,
    likes: 2980,
    comments: 387,
    isHot: false,
    isNew: false,
    isFeatured: false,
    tags: ['婆媳关系', '家庭和谐', '婚姻智慧'],
    coverImage: 'https://readdy.ai/api/search-image?query=warm%20kitchen%20scene%20with%20two%20women%20of%20different%20generations%20cooking%20together%2C%20laughing%20and%20sharing%20a%20tender%20moment%2C%20soft%20warm%20lighting%2C%20cozy%20family%20atmosphere%2C%20lifestyle%20photography&width=800&height=480&seq=article-cover-12&orientation=landscape',
  },
];

export const aboutInfo = {
  brand: {
    name: '爱情岛论坛',
    slogan: '让每一份情感都被温柔以待',
    founded: '2018年3月',
    members: '超过120万注册会员',
    description: `爱情岛论坛成立于2018年，是一个专注于情感交流与恋爱话题的中文社区平台。我们致力于为每一位用户提供一个温暖、真诚、开放的交流空间，让情感不再是一座孤岛。

自成立以来，爱情岛论坛始终坚持"真诚交流，共同成长"的核心理念。在这里，你可以分享自己的情感故事，获取专业的恋爱建议，参与丰富的社区互动，结识志同道合的朋友。

我们汇聚了情感咨询师、婚姻家庭指导师、心理学专家等专业人士，为社区成员提供高质量的内容和专业的建议。同时，我们定期举办线上线下活动，让社区成员有机会从线上的文字交流走向线下的真实互动。`,
    values: [
      { title: '真诚', desc: '倡导真实、坦诚的交流氛围，让每个人都能在这里做真实的自己' },
      { title: '温暖', desc: '以温暖包容的态度面对每一位社区成员，让情感交流有人情味' },
      { title: '专业', desc: '汇聚专业的情感内容创作者和咨询师，提供有深度的内容' },
      { title: '成长', desc: '帮助每一位社区成员在情感旅程中获得启发和成长' },
    ],
  },
  reputation: {
    testimonials: [
      {
        name: '小雨',
        role: '社区活跃会员，加入3年',
        content: '爱情岛论坛陪伴我走过了失恋最难熬的那段时光。在这里我认识了很多温暖的朋友，看了很多让我释怀的文章。可以说是这个社区帮我重新找回了自信和生活的热情。',
        avatar: 'https://readdy.ai/api/search-image?query=portrait%20of%20a%20young%20Chinese%20woman%20with%20bright%20genuine%20smile%2C%20casual%20outdoor%20setting%2C%20warm%20natural%20lighting%2C%20friendly%20approachable%20look&width=80&height=80&seq=testimonial-01&orientation=squarish',
      },
      {
        name: '大伟',
        role: '社区版主，加入4年',
        content: '从一个默默看帖的潜水党，到成为社区版主，爱情岛见证了我的整个恋爱和婚姻历程。在这里分享自己的故事、帮助其他岛友解决问题，是一件非常有意义的事。',
        avatar: 'https://readdy.ai/api/search-image?query=portrait%20of%20a%20Chinese%20man%20in%20his%20early%20thirties%20with%20confident%20friendly%20smile%2C%20casual%20professional%20look%2C%20warm%20lighting&width=80&height=80&seq=testimonial-02&orientation=squarish',
      },
      {
        name: '心理咨询师林悦',
        role: '情感专栏作者',
        content: '作为心理咨询师，我很高兴能通过爱情岛这个平台帮助到更多的人。这里的社区氛围真诚而温暖，每一次和岛友的交流互动，都让我感受到这个社区的价值和意义。',
        avatar: 'https://readdy.ai/api/search-image?query=portrait%20of%20a%20professional%20Chinese%20woman%20with%20glasses%2C%20warm%20professional%20smile%2C%20therapist%20style%2C%20clean%20studio%20background&width=80&height=80&seq=testimonial-03&orientation=squarish',
      },
    ],
    stats: [
      { value: '120万+', label: '注册会员' },
      { value: '50万+', label: '每日活跃用户' },
      { value: '800万+', label: '累计帖子' },
      { value: '98.5%', label: '用户满意度' },
    ],
  },
  contact: {
    email: 'hello@aiqingdao.com',
    wechat: 'aiqingdao_forum',
    qq: '800123456',
    address: '浙江省杭州市西湖区文三路478号华星时代广场A座12层',
    workingHours: '周一至周五 9:00 - 18:00',
    phone: '0571-88889999',
  },
  timeline: [
    { year: '2018', event: '爱情岛论坛正式上线，开启情感社区之旅' },
    { year: '2019', event: '注册会员突破10万，推出情感问答专栏' },
    { year: '2020', event: '上线移动端适配，推出"情感树洞"匿名倾诉功能' },
    { year: '2021', event: '注册会员突破50万，举办首届线下交友活动' },
    { year: '2022', event: '引入专业情感咨询师团队，开设心理情感专区' },
    { year: '2023', event: '注册会员突破100万，成为国内知名情感社区平台' },
    { year: '2024', event: '推出"爱情岛学院"系列课程，提供体系化的情感教育内容' },
    { year: '2025', event: '注册会员突破120万，全面升级社区互动体验' },
  ],
};